'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'starship';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e039';
var svgPathData = 'M624 256a176 176 0 1 0 -352 0 176 176 0 1 0 352 0zm16 0c0 106-86 192-192 192c-83.8 0-155.1-53.7-181.3-128.6L183.3 308l-1.7 1.7L139.3 352l60.7 0c22.1 0 40 17.9 40 40s-17.9 40-40 40L40 432c-22.1 0-40-17.9-40-40s17.9-40 40-40l76.7 0 46.7-46.7-36.8-5C104.5 297.2 88 278.3 88 256s16.5-41.2 38.6-44.3l36.8-5L116.7 160 40 160c-22.1 0-40-17.9-40-40S17.9 80 40 80l160 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-60.7 0 42.3 42.3 1.7 1.7 83.4-11.4C292.9 117.7 364.2 64 448 64c106 0 192 86 192 192zM261.7 209.5L128.8 227.6C114.6 229.5 104 241.7 104 256s10.6 26.5 24.8 28.4l132.9 18.1C258 287.6 256 272 256 256s2-31.6 5.7-46.5zM16 120c0 13.3 10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 96c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 368zm408-48a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarship = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;